export enum InsuranceCoverage {
	cashPay = 'CASH_PAY',
	outOfNetwork = 'INSURED_OUT_OF_NETWORK',
	inNetworkWithCopay = 'INSURED_IN_NETWORK_WITH_COPAY',
	inNetworkNoCopay = 'INSURED_IN_NETWORK_NO_COPAY',
}

export enum ExemptionType {
	waiver = 'WAIVER',
	employer = 'EMPLOYER',
	insurance = 'INSURANCE',
}

export interface IWaivable {
	isMembershipWaivable: IServiceWaivable;
}

export interface IServiceWaivable {
	isWaivable: boolean;
	exemptBy?: ExemptionType;
}

export interface IInsuranceWaivable extends IServiceWaivable {
	inNetwork: boolean;
}
